export default __webpack_public_path__ + "static/media/kpi-management.cc8ee97d.svg";